import { fg } from '@atlassian/jira-feature-gating';

const ENCODE_MAP = {
	'\t': '\\t',
	'\n': '\\n',
	'\r': '\\r',
	'"': '\\"',
	"'": "\\'",
	'\\': '\\\\',
} as const;

export const encodeCharacter = (character: string, ignoredCharacter?: string) => {
	if (character === ignoredCharacter) {
		return character;
	}

	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
	return ENCODE_MAP[character] || character;
};

/**
 * Used to create a quoted string for a JQL query.
 * Must be used with a user-created parameters as they may contain bad characters
 */
export const toQuotedString = (parameter: string) => {
	let escaped = '';
	for (let position = 0; position < parameter.length; position += 1) {
		escaped += encodeCharacter(parameter[position], "'");
	}

	return `"${escaped}"`;
};

/**
 * Encodes a JQL string as a URI component for the project "All work" route. Note that "All work"
 * and "List" views are merging behind 'jira_list_nin_merge', and will be referred to as "List"
 * moving forward.
 */
export const createProjectAllWorkUri = (jql: string): string =>
	fg('jira_list_nin_merge')
		? `/list/?jql=${encodeURIComponent(jql)}`
		: `/issues/?jql=${encodeURIComponent(jql)}`;

/**
 * Encodes a JQL string as a URI component for the global issues/'All work' route.
 */
export const createAllWorkUrl = (jql: string) => `/issues/?jql=${encodeURIComponent(jql)}`;
